
export const convertSecondsToSpace = (seconds, buffer, width) => {
    if (!buffer) {
        return 0;
    }
    return seconds  / buffer.duration * width;
}


export const convertSpaceToSeconds = (x, buffer, width) => {
    if (!buffer) {
        return 0;
    }
    return buffer.duration * x / width;
};

